<template>
  <Transition name="slide-fade" appear>
    <div v-if="visible" class="modal-end">
      <div class="modal-content" :style="{width: size + '%'}">
        <div class="modal-header-title">
          <span class="modal-header-txt">{{$t('group_assign')}}</span>
        </div>
        <div class="list-user-title">
          <div class="search-select-wrapper">
            <span class="list-user-txt">{{ $t('users_title') }}</span>
            <div class="custom-multiselect-wrapper">
              <multiselect
                  class="custom-multiselect-box invite-user"
                  v-model="addMultipleUsers"
                  :options="filteredDepartmentOptions"
                  track-by="value"
                  label="text"
                  :multiple="false"
                  :placeholder="$t('multiple_assign')"
                  selectLabel=""
                  deselectLabel=""
                  selectedLabel=""
                  :internal-search="false"
                  @search-change="onDepartmentSearch"
              >
                <template #noOptions>
                  <span class="no-data-found">{{$t('no_data_found')}}</span>
                </template>
              </multiselect>
            </div>
            <div class="custom-search-wrapper">
              <img src="@/assets/images/search.svg" />
              <input class="custom-search-input" type="text" :placeholder="$t('search_type')" v-model="searchQuery" v-on:keyup.enter="handleInviteSearch"/>
              <div v-if="searchQuery" class="searchBarCross" @click="resetSearch">
                <img class="cross" src="../../assets/images/cross.svg" />
              </div>
            </div>
          </div>
        </div>
        <div class="list-user-div scroll-design" v-scroll-end="loadMore">
          <div class="list-user-item" :class="{ 'multiple-mode': addMultipleUsers }" v-if="this.filteredUsers.length===0" v-for="user in usersData" @click="() => checkUser(user)" :key="user.userId">
            <div v-if="addMultipleUsers" :key="addMultipleUsers">
              <img @click="updateUserDeps(user)" v-if="(!isPartOfDep(user.departmentIds)) && addMultipleUsers!==null" src="@/assets/images/checkbox-circle.svg" />
              <img @click="removeUserDeps(user)" v-if="(isPartOfDep(user.departmentIds)) && addMultipleUsers!==null" src="@/assets/images/checkboxchecked-circle.svg" />
            </div>
            <div class="user-avatar-div initials">
              {{ getUserInitials(user.email) }}
            </div>

            <span class="user-email" :class="{ 'no-limit': addMultipleUsers }">{{ user.email }}</span>

            <div v-if="addMultipleUsers===null">
              <SelectBox
                  :loading="user.userId === getUserId"
                  class="select-box"
                  :options="selectboxOptions"
                  :on-select="(selectedValue) => handleRoleSelectByUser(selectedValue, user)"
                  :selected-value="user.roleId"
                  :placeholder="$t('select_a_role')"
                  :align-right="true"
              />
            </div>

            <div v-if="addMultipleUsers===null">
              <multiselect
                  v-model="user.departmentIds"
                  :options="filteredDepartmentOptions"
                  track-by="value"
                  label="text"
                  :multiple="true"
                  :placeholder="$t('select_a_department')"
                  selectLabel=""
                  deselectLabel=""
                  selectedLabel=""
                  :internal-search="false"
                  @search-change="onDepartmentSearch"
                  @select="(selectedOption) => onDepartmentSelect(selectedOption, user)"
                  @remove="(removedOption) => onDepartmentRemove(removedOption, user)"
              >
                <template #noOptions>
                  <span class="no-data-found">{{$t('no_data_found')}}</span>
                </template>
              </multiselect>
            </div>

            <span v-if="user?.isChanged ?? false" class="save-btn" @click="updateRole(user)">
              {{ $t('save_button') }}
            </span>

            <div v-if="user.userId !== getUserId" class="user-avatar-div" @click="showDeleteModal(user.userId)">
              <img src="../../assets/images/trash.svg">
            </div>

            <div v-else class="user-avatar-div bg-none"></div>
          </div>

          <div class="list-user-item" :class="{ 'multiple-mode': addMultipleUsers }" v-if="this.filteredUsers.length!==0" v-for="user in filteredUsers" @click="() => checkUser(user)" :key="user.userId">
            <div v-if="addMultipleUsers" :key="addMultipleUsers">
              <img @click="updateUserDeps(user)" v-if="(!isPartOfDep(user.departmentIds)) && addMultipleUsers!==null" src="@/assets/images/checkbox-circle.svg" />
              <img @click="removeUserDeps(user)" v-if="(isPartOfDep(user.departmentIds)) && addMultipleUsers!==null" src="@/assets/images/checkboxchecked-circle.svg" />
            </div>
            <div class="user-avatar-div initials">
              {{ getUserInitials(user.email) }}
            </div>

            <span class="user-email" :class="{ 'no-limit': addMultipleUsers }">{{ user.email }}</span>

            <div class="mt-3" v-if="addMultipleUsers===null">
              <SelectBox
                  :loading="user.userId === getUserId"
                  class="select-box"
                  :options="selectboxOptions"
                  :on-select="(selectedValue) => handleRoleSelectByUser(selectedValue, user)"
                  :selected-value="user.roleId"
                  :placeholder="$t('select_a_role')"
                  :align-right="true"
              />
            </div>

            <div v-if="addMultipleUsers===null">
              <multiselect
                  class="mt-3"
                  v-model="user.departmentIds"
                  :options="filteredDepartmentOptions"
                  track-by="value"
                  label="text"
                  :multiple="true"
                  :placeholder="$t('select_a_department')"
                  selectLabel=""
                  deselectLabel=""
                  selectedLabel=""
                  :internal-search="false"
                  @search-change="onDepartmentSearch"
                  @select="(selectedOption) => onDepartmentSelect(selectedOption, user)"
                  @remove="(removedOption) => onDepartmentRemove(removedOption, user)"
              >
                <template #noOptions>
                  <span class="no-data-found">{{$t('no_data_found')}}</span>
                </template>
              </multiselect>
            </div>

            <span v-if="user?.isChanged ?? false" class="save-btn" @click="updateRole(user)">
              {{ $t('save_button') }}
            </span>

            <div v-if="user.userId !== getUserId" class="user-avatar-div" @click="showDeleteModal(user.userId)">
              <img src="../../assets/images/trash.svg">
            </div>

            <div v-else class="user-avatar-div bg-none"></div>
          </div>
          <div v-if="isLoading" class="loading-center">
            <VueSpinner size="32"/>
          </div>

        </div>

        <div class="btn-div2">
          <div v-if="addMultipleUsers" class="primary-button" @click="this.addMultiple">
            <span class="next-txt">{{$t('multiple_assign')}}</span>
          </div>
          <div class="dark-button" @click="this.handleModalClose">
            <span class="next-txt">{{ $t('done') }}</span>
          </div>
        </div>

        <SuccessModal :is-Visible="showSuccessModal" :on-close="onClose" :on-action="onClose"/>
        <div @click="this.handleModalClose" class="close-btn">
          <img class="cross" src="/src/assets/images/cross.svg"/>
        </div>
      </div>
    </div>
  </Transition>

  <ConfirmDeleteModal
      :title="this.$t('alert_messages')"
      :message="this.$t('alert_messages_two')"
      :is-visible="deleteModalVisible"
      :on-action="onDeleteInvite"
      :on-close="handleDeleteModalClose"
  />
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import SelectBox from "@/components/SelectBox.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import inviteService from "@/service/inviteService";
import {
  VueSpinnerIos
} from 'vue3-spinners'
import {handleErrorResponse} from "@/utils/utils";
import ConfirmDeleteModal from "@/components/modals/ConfirmDeleteModal.vue";
import FileDrop from "@/components/FileDrop.vue";
import roleService from "../../service/roleService";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    FileDrop,
    ConfirmDeleteModal,
    SuccessModal,
    TextInput,
    SelectBox,
    VueSpinnerIos
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {
      }
    },
    companyId: {
      type: String,
      default: null
    },

    size: {
      type: String,
      default: 50
    },

    roleList: {
      type: Array,
      default: []
    },
    deps: {
      type: Array,
      default: []
    }
  },

  computed: {
    getUserId() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user.userId;
    },
    filteredDepartmentOptions() {
      if (!this.departmentSearchQuery) {
        return this.selectboxOptions2;
      }
      const query = this.departmentSearchQuery.toLocaleLowerCase('tr');
      return this.selectboxOptions2.filter(option =>
        option.text && option.text.toLocaleLowerCase('tr').includes(query)
      );
    }
  },

  data() {
    return {
      filteredUsers:[],
      searchQuery: "",
      isExpanded: false,
      assignIds: [],
      addMultipleUsers: null,
      addLoading: false,
      isModalVisible: false,
      showSuccessModal: false,
      deleteModalVisible: false,
      csvImport: false,
      isLoading: true,
      currentPage: 1,
      userId: 0,
      csvFile: null,
      selectboxOptions: [],
      selectboxOptions2: [],
      usersData: [],
      inviteData: {
        email: "",
        roleId: "",
        departmentId: "",
        departmentIds: [],
      },
      departmentSearchQuery: '',
    };
  },

  mounted() {
  },

  watch: {
    visible(newVal) {
      if (newVal && this.companyId) {
        this.initData();
      }
    },
    companyId(newVal) {
      if (newVal !== null && newVal !== undefined) {
        this.initData();
      }
    },
    roleList: {
      handler: function (newVal, oldVal) {
        if (newVal.length > 0) {
          this.selectboxOptions = newVal.map(role => ({
            text: role.name,
            value: role.id,
          }));
        }
      },
      deep: true,
      immediate: true,
    },
    deps: {
      handler: function (newVal, oldVal) {
        if (newVal.length > 0) {
          this.selectboxOptions2 = newVal.map(dep => ({
            text: dep.name,
            value: dep.departmentId,
          }));
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    onDepartmentSearch(query) {
      this.departmentSearchQuery = query;
    },
    resetModalState() {
      this.addMultipleUsers = null;
      this.assignIds = [];
      this.searchQuery = "";
      this.filteredUsers = [];
    },

    handleModalClose() {
      this.resetModalState();
      this.onHide();
    },

    initData() {

      this.selectboxOptions = this.roleList.map(role => ({
        text: role.name,
        value: role.id,
      }));

      if (this.companyId === null || this.companyId === undefined) {
        this.$snackbar.add({
          text: this.$t('company_id_not_set'),
          type: 'error',
        });
        this.onClose();
        return;
      } else {

        inviteService.getInvitedUsers(1, this.companyId).then(response => {
          this.usersData = response.data;

          this.usersData.forEach(user => {
            if (user.departmentIds) {
              const departmentUUIDs = user.departmentIds.map(dep => dep.uuid);
              user.departmentIds = this.selectboxOptions2.filter(option =>
                  departmentUUIDs.includes(option.value)
              );
            } else {
              user.departmentIds = [];
            }
          });

          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
        });
      }

      this.selectboxOptions = this.roleList.map(role => ({
        text: role.name,
        value: role.id,
      }));

      this.selectboxOptions2 = this.deps.map(dep => ({
        text: dep.name,
        value: dep.departmentId,
      }));
    },
    resetSearch(){
      this.searchQuery = "";
      this.filteredUsers=[];
    },

    handleInviteSearch() {
      const query = this.searchQuery.toLowerCase().trim();
      this.filteredUsers = this.usersData.filter(user =>
          user.email.toLowerCase().includes(query)
      );
    },
    updateUserDeps(user){
      user.departmentIds.push(this.addMultipleUsers);
    },
    removeUserDeps(user) {
      user.departmentIds = user.departmentIds.filter(dep => dep.value !== this.addMultipleUsers.value);
    },
    addMultiple(){
      for(const assign of this.assignIds){
        const matchedUser = this.usersData.find(user => user.userId === assign.userId);
        let departmentUUIDs = matchedUser.departmentIds.map(dep => dep.value);
        departmentUUIDs = [...new Set(departmentUUIDs)];
        const updateData = {
          userId: matchedUser.userId,
          roleId: matchedUser.roleId,
          departmentIds: departmentUUIDs
        };

        roleService.updateUserRole(updateData).then(response => {
          this.$snackbar.add({
            text: response.data.message,
            type: 'success',
          })
        }).catch(error => {
          this.$snackbar.add({
            text: error.response?.data?.message || 'An error occurred',
            type: 'error',
          });
        });
      }
      this.assignIds=[];
    },
    checkUser(user) {
      if (!this.assignIds.map(item => item.userId).includes(user.userId)) {
        this.assignIds.push({
          userId: user.userId,
          roleId: user.roleId
        });
        this.onDepartmentIdsChanged(this.addMultipleUsers, user.userId)
      }
    },

    isPartOfDep(id) {
      return id.includes(this.addMultipleUsers);
    },
    getUserInitials(name) {
      return name.substr(0, 1).toUpperCase();
    },

    onClose() {
      this.showSuccessModal = false;
    },

    onSave() {
      this.showSuccessModal = true;
      event.stopPropagation();
    },

    handleRoleSelectByUser(value, user) {
      if (!user.oldRoleId) {
        user.oldRoleId = user.roleId;
      }

      if (!user.oldDepartmentIds) {
        user.oldDepartmentIds = JSON.parse(JSON.stringify(user.departmentIds));
      }

      const oldDeptIds = (user.oldDepartmentIds || []).map(d => d.value).sort();
      const newDeptIds = (user.departmentIds || []).map(d => d.value).sort();

      user.isChanged = user.oldRoleId !== value ||
          JSON.stringify(oldDeptIds) !== JSON.stringify(newDeptIds);

      user.roleId = value;

      this.$forceUpdate();
    },

    onDepartmentIdsChanged(value, user) {
      if (!user.oldDepartmentIds) {
        user.oldDepartmentIds = JSON.parse(JSON.stringify(user.departmentIds));
      }

      if (!user.oldRoleId) {
        user.oldRoleId = user.roleId;
      }

      const oldDeptIds = (user.oldDepartmentIds || []).map(d => d.value).sort();
      const newDeptIds = (value || []).map(d => d.value).sort();

      user.isChanged = JSON.stringify(oldDeptIds) !== JSON.stringify(newDeptIds) ||
          (user.oldRoleId && user.oldRoleId !== user.roleId);

      user.departmentIds = value;

      this.$forceUpdate();
    },

    onInvite() {
      if (this.inviteData.email === "") {
        this.$snackbar.add({
          text: this.$t('please_enter_user_email'),
          type: 'error',
        });
        return;
      }

      const tempData = {
        ...this.inviteData,
        companyId: this.companyId,
        departmentIds: this.inviteData.departmentIds.map(dep => dep.value)
      }

      this.addLoading = true;

      inviteService.inviteUser(tempData).then(response => {
        this.showSuccessModal = true;
        this.inviteData.email = "";
        this.inviteData.roleId = "";
        this.inviteData.departmentId = "";
        this.inviteData.departmentIds = [];

        this.initData();
      }).catch(error => {
        this.addLoading = false;
        handleErrorResponse(error, this.$snackbar);
      });
    },

    showDeleteModal(id) {
      this.userId = id;
      this.deleteModalVisible = true;
      event.stopPropagation();
    },
    handleDeleteModalClose() {
      this.deleteModalVisible = false;
    },
    onDeleteInvite() {
      inviteService.deleteInvite(this.userId).then(() => {
        this.initData();
        this.deleteModalVisible = false;
      }).catch(error => {
        handleErrorResponse(error, this.$snackbar);
      })
    },

    loadMore() {
      if (!this.lastPage && !this.isLoading) {
        this.isLoading = true;
        this.currentPage++;
        this.loadScroll();
      }
    },

    loadScroll() {
      inviteService.getInvitedUsers(this.currentPage, this.companyId).then(response => {
        this.data = response.data;
        if (response.data.data.last_page === this.currentPage) {
          this.lastPage = true;
        }

        const newUsers = response.data.data.data;

        newUsers.forEach(user => {
          if (user.departmentId) {
            const dept = this.selectboxOptions2.find(opt => opt.value === user.departmentId);
            user.departmentIds = dept ? [dept] : [];
          } else {
            user.departmentIds = [];
          }
        });

        this.usersData = [...this.usersData, ...newUsers];
        this.isLoading = false;
      }).catch(error => {
      });
    },

    updateRole(user) {
      const departmentIds = user.departmentIds.map(dep => dep.value);
      const roleIdToSend = user.roleId || user.oldRoleId || null;

      if (!roleIdToSend) {
        this.$snackbar.add({
          text: this.$t('please_choose_role'),
          type: 'error',
        });
        return;
      }

      const updateData = {
        userId: user.userId,
        roleId: roleIdToSend,
        departmentIds: departmentIds
      };

      roleService.updateUserRole(updateData).then(response => {
        this.$snackbar.add({
          text: response.data.message,
          type: 'success',
        })
        user.isChanged = false;
        delete user.oldRoleId;
        delete user.oldDepartmentIds;

        this.$forceUpdate();
      }).catch(error => {
        this.$snackbar.add({
          text: error.response?.data?.message || 'An error occurred',
          type: 'error',
        });
      });
    },

    onDepartmentSelect(selectedOption, user) {
      if (!user.oldDepartmentIds) {
        user.oldDepartmentIds = JSON.parse(JSON.stringify(user.departmentIds.filter(d => d.value !== selectedOption.value)));
      }

      if (!user.oldRoleId) {
        user.oldRoleId = user.roleId;
      }

      const oldDeptIds = (user.oldDepartmentIds || []).map(d => d.value).sort();
      const newDeptIds = (user.departmentIds || []).map(d => d.value).sort();

      user.isChanged = JSON.stringify(oldDeptIds) !== JSON.stringify(newDeptIds) ||
          (user.oldRoleId && user.oldRoleId !== user.roleId);

      this.$forceUpdate();
    },

    onDepartmentRemove(removedOption, user) {
      if (!user.oldDepartmentIds) {
        user.oldDepartmentIds = JSON.parse(JSON.stringify([...user.departmentIds, removedOption]));
      }

      if (!user.oldRoleId) {
        user.oldRoleId = user.roleId;
      }

      const oldDeptIds = (user.oldDepartmentIds || []).map(d => d.value).sort();
      const newDeptIds = (user.departmentIds || []).map(d => d.value).sort();

      user.isChanged = JSON.stringify(oldDeptIds) !== JSON.stringify(newDeptIds) ||
          (user.oldRoleId && user.oldRoleId !== user.roleId);

      this.$forceUpdate();
    },
  },

};
</script>

<style scoped>
.modal-end {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.modal-content {
  position: relative;
  background-color: white;
  width: 70%;
  max-width: 900px;
  height: 95vh;
  border-radius: 12px;
  padding: 32px;
  overflow-y: auto;
  box-shadow: -5px 0 25px rgba(0, 0, 0, 0.15);
  max-height: calc(100vh - 48px);
}

.modal-content::-webkit-scrollbar {
  width: 10px;
}

.modal-content::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #f5f5f5;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: #cbd5e0;
  border-radius: 10px;
  border: 2px transparent solid;
  background-clip: padding-box;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background-color: #a0aec0;
}

.close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 3000px;
}

.cross {
  padding: 8px;
}

.modal-header-title {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.modal-header-txt {
  font-family: euclid_semi_bold, sans-serif;
  color: #1a202c;
  font-size: 20px;
  font-style: normal;
  line-height: 28px;
}

.btn-style {
  display: flex;
  border-radius: 8px;
  background: #2d3748;
  justify-content: center;
  align-items: center;
  min-width: 140px;
  width: auto;
  padding: 0 24px;
  height: 44px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-style:hover {
  background: #1a202c;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.next-txt {
  font-family: euclid_medium, sans-serif;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  font-weight: 500;
}

.btn-div2 {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
  flex-direction: row;
  gap: 12px;
}

.user-avatar-div {
  display: flex;
  width: 42px !important;
  height: 42px;
  padding: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  font-size: 16px;
  gap: 0;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.user-avatar-div.bg-none {
  background: none;
}

.user-avatar-div:not(.initials):not(.bg-none) {
  background: #f7fafc;
  cursor: pointer;
}

.list-user-div {
  display: flex;
  flex-direction: column;
  gap: 0;
  align-items: flex-start;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 20px;
  min-height: 400px;
  max-height: calc(85vh - 300px);
  padding: 4px;
  background: #f8fafc;
  border-radius: 8px;
}

.list-user-title {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  width: 100%;
}

.list-user-txt {
  font-family: euclid_semi_bold, sans-serif;
  color: #2d3748;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
  font-weight: 600;
}

.user-title-wrapper {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  width: 100%;
}

.search-select-wrapper {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.list-user-item {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  width: 100%;
  padding: 16px 20px;
  border-radius: 8px;
  background-color: #ffffff;
  margin-bottom: 8px;
  justify-content: space-between;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
  cursor: pointer;
  min-height: 70px;
  position: relative;
  overflow: visible;
}

.list-user-item:hover {
  background-color: #f7fafc;
  border-color: #cbd5e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.list-user-item.multiple-mode {
  justify-content: flex-start;
  padding: 16px 20px;
}

.user-email {
  flex: 1;
  font-size: 14px;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #4a5568;
  font-weight: 500;
}

.user-email.no-limit {
  max-width: none;
  overflow: visible;
  text-overflow: unset;
  white-space: normal;
}

.save-btn {
  font-size: 13px;
  font-family: euclid_medium, sans-serif;
  color: #ffffff;
  cursor: pointer;
  background: #10b981;
  padding: 6px 16px;
  border-radius: 6px;
  border: none;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.save-btn:hover {
  background: #059669;
}

.custom-multiselect-wrapper {
  flex: 1;
  max-width: 315px;
  min-width: 180px;
}

.custom-multiselect-box :deep(.multiselect__tags) {
  min-height: 42px !important;
  height: 42px !important;
  display: flex !important;
  align-items: center !important;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.custom-multiselect-box :deep(.multiselect__tags:hover) {
  border-color: #cbd5e0;
}

.custom-multiselect-box :deep(.multiselect__placeholder) {
  line-height: 28px !important;
  margin: 0 !important;
  padding: 0 12px !important;
  color: #718096;
}

.custom-multiselect-box :deep(.multiselect__single) {
  line-height: 28px !important;
  margin: 0 !important;
  padding: 0 12px !important;
  color: #2d3748;
}

.custom-search-wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  border-radius: 8px;
  height: 42px;
  flex: 2;
  max-width: 400px;
  transition: all 0.2s ease;
}

.custom-search-wrapper:focus-within {
  border-color: #805ad5;
  box-shadow: 0 0 0 3px rgba(128, 90, 213, 0.1);
}

.custom-search-wrapper img {
  margin-left: 12px;
  opacity: 0.5;
}

.custom-search-input {
  border: none;
  outline: none;
  background-color: transparent;
  padding: 0 12px;
  width: 100%;
  height: 38px;
  line-height: 38px;
  font-size: 14px;
  color: #2d3748;
}

.custom-search-input::placeholder {
  color: #a0aec0;
}

.searchBarCross {
  margin-right: 8px;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.searchBarCross:hover {
  opacity: 1;
}

:deep(.multiselect__content-wrapper) {
  min-width: 180px !important;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
  max-height: 170px !important;
  z-index: 999;
  position: absolute !important;
}

:deep(.multiselect__tags) {
  min-width: 180px;
  border-radius: 8px;
}

:deep(.select-box-wrapper) {
  width: 180px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

:deep(.multiselect__placeholder) {
  color: #718096;
  font-size: 14px;
  margin-bottom: 0;
  padding-top: 0;
  padding-left: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
}

:deep(.select-custom-content){
  z-index: 999;
  position: absolute !important;
}

.loading-center {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  width: 100%;
}

/* Tablet - 1024px */
@media (max-width: 1024px) {
  .modal-content {
    width: 95%;
    padding: 24px;
    height: 90vh;
  }

  .search-select-wrapper {
    flex-wrap: wrap;
    gap: 10px;
  }

  .custom-multiselect-wrapper {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .custom-search-wrapper {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .list-user-item {
    gap: 12px;
    padding: 14px 16px;
  }

  .user-email {
    max-width: 200px;
  }

  :deep(.select-box-wrapper) {
    width: 150px;
  }

  :deep(.multiselect__tags) {
    min-width: 150px;
  }
}

/* Mobile - 768px */
@media (max-width: 768px) {
  .modal-content {
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    padding: 20px;
  }

  .modal-header-title {
    padding-bottom: 12px;
  }

  .list-user-div {
    max-height: calc(100vh - 280px);
    min-height: 300px;
  }

  /* Mobile'da grid layout kullan */
  .list-user-item {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto auto;
    gap: 10px;
    padding: 12px;
    min-height: auto;
  }

  /* Avatar ve email ilk satır */
  .user-avatar-div.initials {
    grid-column: 1;
    grid-row: 1;
  }

  .user-email {
    grid-column: 2;
    grid-row: 1;
    max-width: 100%;
    align-self: center;
  }

  /* Delete butonu sağ üst */
  .list-user-item > div:last-child {
    grid-column: 3;
    grid-row: 1;
  }

  /* Select ve multiselect ikinci satır */
  .list-user-item > div:has(.select-box) {
    grid-column: 1 / span 2;
    grid-row: 2;
  }

  .list-user-item > div:has(.multiselect) {
    grid-column: 1 / span 2;
    grid-row: 3;
  }

  .save-btn {
    grid-column: 3;
    grid-row: 2 / span 2;
    align-self: center;
    justify-self: end;
  }


  .list-user-item.multiple-mode {
    grid-template-columns: auto auto 1fr;
    grid-template-rows: auto;
    padding: 12px;
  }

  .btn-style {
    width: 48%;
    min-width: auto;
  }

  .btn-div2 {
    flex-wrap: wrap;
    gap: 10px;
  }

  :deep(.select-box-wrapper) {
    width: 100%;
  }

  :deep(.multiselect__tags) {
    width: 100%;
    min-width: unset;
  }

  .custom-multiselect-box :deep(.multiselect__tags) {
    min-height: 38px !important;
    height: 38px !important;
  }
}

/* Small Mobile - 498px */
@media (max-width: 498px) {
  .modal-content {
    padding: 16px;
  }

  .modal-header-txt {
    font-size: 18px;
  }

  .close-btn {
    width: 36px;
    height: 36px;
    top: 16px;
    right: 16px;
  }

  .btn-style {
    width: 100%;
    height: 42px;
  }

  .btn-div2 {
    flex-direction: column;
    gap: 8px;
  }

  .list-user-item {
    padding: 10px;
    gap: 8px;
  }

  .user-avatar-div {
    width: 36px !important;
    height: 36px !important;
    font-size: 14px;
  }

  .user-email {
    font-size: 13px;
  }

  .save-btn {
    font-size: 12px;
    padding: 4px 12px;
  }


  .custom-search-wrapper {
    height: 38px;
  }

  .custom-search-input {
    height: 34px;
    line-height: 34px;
    font-size: 13px;
  }

  :deep(.multiselect__tags) {
    min-height: 36px !important;
    height: 36px !important;
  }

  :deep(.multiselect__placeholder) {
    font-size: 13px;
  }

  :deep(.multiselect__single) {
    font-size: 13px;
  }
}

/* Landscape mobile özel durumu */
@media (max-width: 768px) and (orientation: landscape) {
  .modal-content {
    height: 100vh;
    max-height: 100vh;
  }

  .list-user-div {
    max-height: calc(100vh - 240px);
    min-height: 200px;
  }
}
</style>
